/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import Ladda from 'ladda';
import { View } from 'backbone.marionette';
import Syphon from 'backbone.syphon';

import PhoneFormatBehavior from '@/behaviors/PhoneFormatBehavior';
import { validateForm } from '@/util/ParsleyUtils';

import InsertCommandPOC from '../../services/InsertCommandPOC';
import UpdateCommandPOC from '../../services/UpdateCommandPOC';

//import './SelectCommandModalView.css';

import tmplPOCDetailsModalView from './POCDetailsModalView.hbs';

const POCDetailsModalView = View.extend({
  template: tmplPOCDetailsModalView,

  className: 'poc-details-modal-view',

  ui: {
    pocForm: '.poc-form',
    btnCancel: '.btn-cancel',
    btnSave: '.btn-save',
    phoneFormat: '.phone-format'
  },

  events: {
    'click @ui.btnCancel': 'onClickCancel',
    'click @ui.btnSave': 'onClickSave'
  },

  triggers: {
    'modal:close': 'modal:close'
  },

  behaviors: {
    telephone: PhoneFormatBehavior
  },

  onRender() {
    if (this.model.get('edit')) {
      Syphon.deserialize(this, this.model.get('data'));
      this.$('#firstName').prop('disabled', true);
      this.$('#lastName').prop('disabled', true);
    }
  },

  toggleForm(state) {
    this.$el.find(':input').prop('disabled', !state);
  },

  onClickCancel(e) {
    e.preventDefault();
    this.triggerMethod('modal:close');
  },

  async onClickSave(e) {
    e.preventDefault();
    const formData = Syphon.serialize(this);
    formData.commandID = this.model.get('commandID');

    const spinner = Ladda.create(this.ui.btnSave[0]);
    spinner.start();

    try {
      await validateForm(this.ui.pocForm);
      // Manually add type
      const pocType = _.find(this.model.get('pocTypes'), (pocType) => {
        return pocType.id === formData.typeID;
      });
      formData.type = pocType.name;

      this.toggleForm(false);

      const isSubmit = this.model.get('isSubmit');

      if (this.model.get('edit')) {
        formData.id = this.model.get('data').id;
        await UpdateCommandPOC(formData);
        this.triggerMethod('modal:close', formData);
      } else {
        if (isSubmit) {
          const response = await InsertCommandPOC(formData);
          formData.id = response.id;
        }
        this.triggerMethod('modal:close', formData);
      }
    } catch (err) {
      // Ignore validation error
    } finally {
      spinner.stop();
      this.toggleForm(true);
    }
  }
});

export default POCDetailsModalView;
